import { LinkProps, Link } from '@reach/router';
import React from 'react';
import { useSmartTo } from 'hooks/useSmartNavigate';

export const SmartLink = React.forwardRef<HTMLAnchorElement, LinkProps<Record<string, unknown>>>(function SmartLink({ to, children, ...props }, ref) {
  const format = useSmartTo();

  return (
    <Link ref={ref as unknown as any} to={format(to)} {...props}>
      {children}
    </Link>
  );
});
